import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";

export default function AdminBookings() {
    const [items, setItems] = useState([]);
    const load = () => api.get("/admin/bookings").then(({ data }) => setItems(data.items));
    useEffect(() => { load(); }, []);

    const setStatus = async (id, status) => {
        try { await api.patch(`/admin/bookings/${id}`, { status }); toast.success(`Marked ${status}`); load(); } catch { toast.error("Failed"); }
    };

    return (
        <div data-testid="admin-bookings">
            <div className="font-mono-brand text-xs uppercase tracking-[0.25em] text-[hsl(var(--ink-soft))]">Bay</div>
            <h1 className="mt-1 font-display text-4xl uppercase italic text-[hsl(var(--ink))]">Bookings</h1>
            <div className="mt-6 space-y-3">
                {items.length === 0 && (
                    <div className="border-2 border-dashed border-[hsl(var(--dust-300))] p-8 text-center text-[hsl(var(--ink-soft))]">No booking requests yet.</div>
                )}
                {items.map((b) => (
                    <div key={b.id} className="border-2 border-[hsl(var(--ink))] bg-card p-5">
                        <div className="flex flex-wrap items-start justify-between gap-3">
                            <div>
                                <div className="font-heading text-base uppercase text-[hsl(var(--ink))]">{b.service}</div>
                                <div className="font-mono-brand text-xs text-[hsl(var(--ink-soft))]">
                                    {b.name} · {b.email} {b.phone && `· ${b.phone}`} · requested {new Date(b.created_at).toLocaleString()}
                                </div>
                                <div className="mt-1 font-mono-brand text-xs text-[hsl(var(--forest))]">Preferred: {b.preferred_date}</div>
                                {b.rig && <div className="mt-1 font-mono-brand text-xs">rig: {b.rig}</div>}
                            </div>
                            <div className="flex flex-wrap gap-2">
                                <span className="border border-[hsl(var(--ink))] px-2 py-1 font-mono-brand text-[10px] uppercase">{b.status}</span>
                                {["confirmed", "completed", "cancelled"].map((s) => (
                                    <button key={s} onClick={() => setStatus(b.id, s)} className="border border-[hsl(var(--ink))] px-3 py-1 font-heading text-xs uppercase tracking-wider hover:bg-[hsl(var(--ink))] hover:text-[hsl(var(--dust-50))]">
                                        {s}
                                    </button>
                                ))}
                            </div>
                        </div>
                        {b.notes && <p className="mt-3 whitespace-pre-wrap text-sm text-[hsl(var(--ink))]">{b.notes}</p>}
                    </div>
                ))}
            </div>
        </div>
    );
}
